import projectUtils from "../../../../utils/project-utils.js";

// ================================================
// INITIAL STATES & MODELS
// ================================================
export const lanesCapturePlace = {
  address: "",
  number: "",
  neighborhood: "",
  city: "",
  latitude: "",
  longitude: "",
  description: "",
  group: "",
  mobile: false,
  zipcode: "",
}

export const lanesRoute = {
    code: "",
    description: "",
    regionType: "",
    procedureImageid: "",
    file: "",
}

export const lanesLane = {
  code: "",
  status: true,
  restricted: false,
  description: "",
  type: "",
  smartcapturePin: "",
  maintenanceGroupsId: "",
  observation: "",
  noctime: 60,
  ocr: "",
  images: "",
  rumination: false,
  classification: false,
  showlane: false,
  laneKey: "",
  archiver: ""
}

export const basicSetups = {
  driver: "",
  model: "",
  disableConnection: false,
  realTime: false,
  cameraip: "",
  port: "",
  model_details: {
    ipAddress: "",
    portNo: "",
    user: "",
    password: ""
  }
}

export const createBasicSetup = () => structuredClone(basicSetups);

export const smartcaptureDriver = {
  back: createBasicSetup(),
  forward: createBasicSetup(),
}

// ================================================
// CONST
// ================================================

export const lanesFormMenuItems = [
  {label: "Ponto de coleta + Sentido", value: "pcl-route"},
  {label: "Câmera", value: "lane"},
  {label: "Associação de câmeras de vídeo", value: "cftv"},
  {label: "Configurações", value: "camera"},
  {label: "Ajustes personalizados - Dianteira", value: "camera-settings-forward"},
  {label: "Ajustes personalizados - Traseira", value: "camera-settings-back"},
]

export const regionTypeTranslateObj = {
  ENTRANCE: "Entrada de área monitorada",
  EXIT: "Saída de área monitorada",
  INTERNAL: "Interno a área monitorada",
  EXTERNAL: "Externo a área monitorada",
  MOBILE: "Móvel",
}
export const regionTypesArr = Object.entries(regionTypeTranslateObj).map(([key, value]) => ({value: key, label: value}))

export const laneTypeTranslateObj = {
  API: "API",
  SENTRY_CLOUD: "Sentry Cloud",
  INTERNAL_SMARTCAPTURE: "Smartcapture",
  MOBILE_APP: "App Captura Móvel",
  MOBILE_CAMERA: "Móvel",
  SIMULATOR: "Simulador"
}

export const LaneTypeRules = {
  MOBILE: ["INTERNAL_SMARTCAPTURE", "MOBILE_APP", "MOBILE_CAMERA"],
  DEFAULT: ["API", "SENTRY_CLOUD", "INTERNAL_SMARTCAPTURE"]
}

export const laneTypesArr = Object.entries(laneTypeTranslateObj).map(([key, value]) => ({value: key, label: value}));

export const IMAGE_OPTIONS_RULES = {
  DEFAULT: ["ALL"],
  SENTRY_CLOUD: ["ALL", "ON_DEMAND"],
  API: ["ALL", "TRAFFIC_OFFENCE", "NONE"],
  SIMULATOR: ["ALL", "TRAFFIC_OFFENCE", "NONE"],
  MOBILE_APP: ["ALL", "TRAFFIC_OFFENCE", "NONE"],
  MOBILE_CAMERA: ["ALL", "TRAFFIC_OFFENCE", "NONE"]
};

export const ftpSetupOptions = [
  {label: "Traseira", value: "back"},
  {label: "Dianteira", value: "forward"},
]

export const DRIVERS = [
  {label: 'Alphadigi', value: 'Alphadigi', availableOn: ["back", "forward", "forwardback"], hasMobile: false},
  {label: 'Dahua', value: 'Dahua', availableOn: ["back", "forward"], hasMobile: false},
  {label: 'Hikvision', value: 'Hikvision', availableOn: ["back", "forward"], hasMobile: true},
  {label: 'Intelbras', value: 'Intelbras', availableOn: ["back", "forward"], hasMobile: true},
  {label: 'Milesight', value: 'Milesight', availableOn: ["back", "forward"], hasMobile: false},
  {label: 'Pumatronix', value: 'Pumatronix', availableOn: ["back", "forward", "forwardback"], hasMobile: true},
];

const BASE_PROFILE = {
  defaultPort: 80,
  defaultSmartValue: true,
  defaultRealTimeValue: false,
}

const ENDPOINT_ONLY_CAMERA_MODELS = ["MNVR-AE-MN5043", "VTR600"];

const MODELS_PROFILES = {
  DEFAULT: {
    ...BASE_PROFILE,
    requiredInput: [
      {value: "model_details.ipAddress", label: "Endpoint a ser configurado na câmera"},
      {value: "model_details.portNo", label: "Porta"},
      {value: "cameraip", label: "Endereço da câmera"},
      {value: "port", label: "Porta"},
    ],
  },
  SDK: {
    ...BASE_PROFILE,
    disabledEndPoint: true,
    disabledSmart: true,
    disabledRealTime: true,
    requiredInput: [
      {value: "cameraip", label: "Endereço da câmera"},
      {value: "port", label: "Porta"},
      {value: "model_details.user", label: "Usuário"},
      {value: "model_details.password", label: "Senha"},
    ],
  },
  SDK_USER_NOT_REQUIRED: {
    ...BASE_PROFILE,
    disabledSmart: true,
    disabledEndPoint: true,
    requiredInput: [
      {value: "cameraip", label: "Endereço da câmera"},
      {value: "port", label: "Porta"}
    ],
  },
  ENDPOINT_DISABLED: {
    ...BASE_PROFILE,
    disabledSmart: true,
    disabledRealTime: true,
    disabledEndPoint: true,
    requiredInput: [
      {value: "cameraip", label: "Endereço da câmera"},
      {value: "port", label: "Porta"}
    ],
  },
  ONLY_ENDPOINT_AVAILABLE: {
    defaultPort: 80,
    defaultSmartValue: false,
    defaultRealTimeValue: false,
    disabledSmart: true,
    disabledRealTime: true,
    disabledCameraIp: true,
    disabledPort: true,
    disabledUser: true,
    disabledPassword: true,
    requiredInput: [
      {value: "model_details.ipAddress", label: "Endpoint a ser configurado na câmera"},
      {value: "model_details.portNo", label: "Porta"},
    ],
  },
  PUMATRONIX: {
    defaultPort: 50000,
    defaultSmartValue: true,
    defaultRealTimeValue: false,
    disabledSmart: true,
    disabledRealTime: true,
    disabledEndPoint: true,
    requiredInput: [
      {value: "cameraip", label: "Endereço da câmera"},
      {value: "port", label: "Porta"}
    ],
  }
}
export const MODELS = [
  {label: 'TCAM2021', value: 'tcam2021', modelOf: "Alphadigi", ...MODELS_PROFILES.DEFAULT},
  {label: 'TCAM3130', value: 'tcam3130', modelOf: "Alphadigi", ...MODELS_PROFILES.DEFAULT},
  {label: 'TCAM2021', value: 'tcam2021', modelOf: "Alphadigi", onlyForwardBack: true, ...MODELS_PROFILES.DEFAULT},
  {label: 'TCAM3130', value: 'tcam3130', modelOf: "Alphadigi", onlyForwardBack: true, ...MODELS_PROFILES.DEFAULT},
  {label: 'NetSDK', value: 'NetSDK', modelOf: "Dahua", ...MODELS_PROFILES.SDK},
  {label: 'ITC352 - Smart junto à câmera', value: 'ITC352', modelOf: "Dahua", ...MODELS_PROFILES.ENDPOINT_DISABLED},
  {label: 'ITC431', value: 'ITC431', modelOf: "Dahua", ...MODELS_PROFILES.DEFAULT},
  {label: 'ITC952 - Smart junto à câmera', value: 'ITC952', modelOf: "Dahua", ...MODELS_PROFILES.ENDPOINT_DISABLED},
  {label: 'DS-2CD7A', value: 'ds2cd7a', modelOf: "Hikvision", ...MODELS_PROFILES.DEFAULT},
  {label: 'iDS-2CD7A', value: 'ids2cd7a', modelOf: "Hikvision", ...MODELS_PROFILES.DEFAULT},
  {label: 'MNVR-AE-MN5043', value: 'MNVR-AE-MN5043', modelOf: "Hikvision", ...MODELS_PROFILES.ONLY_ENDPOINT_AVAILABLE},
  {label: 'MNVR-AE-MN5043', value: 'MNVR-AE-MN5043', modelOf: "Hikvision", isMobile: true, ...MODELS_PROFILES.ONLY_ENDPOINT_AVAILABLE},
  {label: 'TCM-203 / TCM-403', value: 'tcm203', modelOf: "Hikvision", ...MODELS_PROFILES.DEFAULT},
  {label: 'TCV-500', value: 'tcv500', modelOf: "Hikvision", ...MODELS_PROFILES.DEFAULT},
  {label: 'AutOCR', value: 'AutOCR', modelOf: "API", ...MODELS_PROFILES.DEFAULT},
  {label: 'NetSDK', value: 'NetSDK', modelOf: "Intelbras", ...MODELS_PROFILES.SDK},
  {label: 'VIP-7260-LPR', value: 'VIP-7260-LPR', modelOf: "Intelbras", ...MODELS_PROFILES.SDK_USER_NOT_REQUIRED},
  {label: 'VIP-94120-API', value: 'VIP-94120-API', modelOf: "Intelbras", ...MODELS_PROFILES.DEFAULT},
  {label: 'MNVD-9004-GW', value: 'MNVD-9004-GW', modelOf: "Intelbras", ...MODELS_PROFILES.ONLY_ENDPOINT_AVAILABLE},
  {label: 'MNVD-9004-GW', value: 'MNVD-9004-GW', modelOf: "Intelbras", isMobile: true, ...MODELS_PROFILES.ONLY_ENDPOINT_AVAILABLE},
  {label: 'VTR600', value: 'VTR600', modelOf: "Pumatronix", isMobile: true, ...MODELS_PROFILES.ONLY_ENDPOINT_AVAILABLE},
  {label: '13L3J', value: '13L3J', modelOf: "Pumatronix", ...MODELS_PROFILES.PUMATRONIX},
  {label: '13L3J', value: '13L3J', modelOf: "Pumatronix", onlyForwardBack: true,...MODELS_PROFILES.PUMATRONIX},
  {label: '401', value: '401', modelOf: "Pumatronix", ...MODELS_PROFILES.PUMATRONIX},
  {label: '403', value: '403', modelOf: "Pumatronix", ...MODELS_PROFILES.PUMATRONIX},
  {label: '411', value: '411', modelOf: "Pumatronix", ...MODELS_PROFILES.PUMATRONIX},
  {label: '411', value: '411', modelOf: "Pumatronix", onlyForwardBack: true, ...MODELS_PROFILES.PUMATRONIX},
  {label: '411N', value: '411N', modelOf: "Pumatronix", ...MODELS_PROFILES.PUMATRONIX},
  {label: '500', value: '500', modelOf: "Pumatronix", ...MODELS_PROFILES.PUMATRONIX},
  {label: '600', value: '600', modelOf: "Pumatronix", ...MODELS_PROFILES.PUMATRONIX},
  {label: '600-API', value: '600-API', modelOf: "Pumatronix",  ...MODELS_PROFILES.DEFAULT},
  {label: '450-API', value: '450-API', modelOf: "Pumatronix",  ...MODELS_PROFILES.DEFAULT},
  {label: 'MS-C2966', value: 'MS-C2966', modelOf: "Milesight", ...MODELS_PROFILES.DEFAULT}
]

export const MODELS_WITH_EXTRA_SETTINGS = [
  "13L3J",
  "401",
  "403",
  "411",
  "411N",
  "500",
]

export const DEFAULT_TRIGGER_TYPE = "physical";

export const triggerTypes = [
  {label: "Indutivo", value: DEFAULT_TRIGGER_TYPE, availableOn: MODELS_WITH_EXTRA_SETTINGS},
  {label: "Virtual Câmera", value: "cameravirtual", availableOn: ["13L3J", "401", "403", "411", "500"]},
  {label: "Virtual Smart", value: "smart", availableOn: ["13L3J", "411"]},
]

export const SMART_LINE_DEFAULTS = {
  smartLineDownX1: 36,
  smartLineDownX2: 100,
  smartLineUpX1: 36,
  smartLineUpX2: 100,
}

const EXTRA_SETTINGS_MODEL_DETAIL_KEYS = [
  "saturacaoDia",
  "saturacaoNoite",
  "contrasteDia",
  "contrasteNoite",
  "numeroFotosDia",
  "numeroFotosNoite",
  "ganhoLuzVisivel",
  "ganhoLuzInfravermelha",
  "shutterMaximo",
  "porcentagemSegundoDisparo",
  "nivelDesejado",
  "smartSensibility",
  "smartIrVirtual",
  "shutterFixo",
  "smartModeNightDay",
  "smartLevelNight",
  "autoIris",
  "wrongWay",
  "smartLineDownX1",
  "smartLineDownX2",
  "smartLineUpX1",
  "smartLineUpX2",
];

export const EXTRA_SETTINGS_RULES = [
  {label: "Saturação", isDayNight: true, dayKey: "saturacaoDia", nightKey: "saturacaoNoite",
    isDisabled: (key, model) => eligibleToDisableKeyModel(key, model), minValue: 0, maxValue: 255},
  {label: "Contraste", isDayNight: true, dayKey: "contrasteDia", nightKey: "contrasteNoite",
    isDisabled: (key, model) => eligibleToDisableKeyModel(key, model), minValue: 0, maxValue: 255},
  {label: "Capturas por pulso", isDayNight: true, dayKey: "numeroFotosDia", nightKey: "numeroFotosNoite" , minValue: 1, maxValue: 3},
  {label: "Ganho máximo", isDayNight: true, dayKey: "ganhoLuzVisivel", nightKey: "ganhoLuzInfravermelha", minValue: 0, maxValue: 72},
  {label: "Shutter máximo", isUniqueFirst: true, key: "shutterMaximo", minValue: 1, maxValue: 1000},
  {label: "Potência do flash no 2º disparo", isUniqueFirst: true, key: "porcentagemSegundoDisparo",
    isDisabled: (model, trigger) => (model === "401" || model === "403")},
  {label: "Nível", isUniqueFirst: true, key: "nivelDesejado", minValue: 7, maxValue: 62},
  {label: "Sensibilidade", isSelect: true, key: "smartSensibility",
    options: [{label: "Baixo", value: "low"},{label: "Média", value: "medium"},{label: "Alta", value: "high"}],
    isDisabled: (model, trigger) => {
      if (trigger === 'smart') return false;
      if (trigger === 'cameravirtual') {
        return !(model === '401' || model === '403');
      }
      return true;
    }
  },
  {label: "Potência do flash no disparo contínuo", key: "smartIrVirtual", isUniqueSecond: true, isDisabled: (model, trigger) => {
      return (trigger !== "smart")
    }, minValue: 1, maxValue: 45},
  {label: "Shutter fixo", key: "shutterFixo",  isUniqueSecond: true,
    isDisabled: (model, trigger) => (model === "403" || model === "411N"), minValue: 1, maxValue: 1000},
  {label: "Foto colorida no modo Night", hasCheckAndValue: true, key: "smartModeNightDay", key2: "smartLevelNight",
    isDisabled: (model, key) => eligibleToDisableKeyModel(null, model), minValue: 1, maxValue: 18},
  {label: "Auto IRIS", onlyCheckBox: true, key: "autoIris"},
  {label: "Captura imagem na contramão", onlyCheckBox: true, key: "wrongWay", isDisabled: (model, trigger) => {
      return (eligibleToDisableKeyModel(null, model) || eligibleToDisableTriggerModel(model, trigger));
    }},
]

// ================================================
// FUNCTIONS
// ================================================

function eligibleToDisableKeyModel(key, model){
  if(key === null){
    return (model === '401' || model === '403' || model === '411N' || model === '500');
  }
  return (key === "noite" && (model === '401' || model === '403' || model === '411N' || model === '500'));
}

function eligibleToDisableTriggerModel(model, trigger){
  return (trigger === "cameravirtual" || trigger === "smart");
}

export function buildFormData(formData) {
  const cleanedCapturePlace = projectUtils.changeEmptyValuesToNull(formData.capturePlace);
  const cleanedLane = projectUtils.changeEmptyValuesToNull(formData.lane);

  const {attach, ...rest} = formData.route

  const cleanedRoute = projectUtils.changeEmptyValuesToNull(rest);
  const driver = formData.smartcaptureDriver;
  let back = null;
  let forward = null;
  let validDriver = null
  let driverCopy = null;

  if(driver && driver?.setup){
    driverCopy = prepareSmartcaptureDriver(driver, driver?.setup)
    if(driver.setup.includes("back")){
      back = projectUtils.removeAttributesWithNoValue(driverCopy.back);
      back = applyEndpointOnlyModelPayloadDefaults(back);
      back = normalizeCameraPort(back);
      if(!Object.hasOwn(back, "cameraip")){
        back.cameraip="";
      }
    }
    if(driver.setup.includes("forward")){
      forward = projectUtils.removeAttributesWithNoValue(driverCopy.forward);
      forward = applyEndpointOnlyModelPayloadDefaults(forward);
      forward = normalizeCameraPort(forward);
      if(!Object.hasOwn(forward, "cameraip")){
        forward.cameraip="";
      }
    }
  }

  if(back || forward){
    validDriver = {
      setup: driver?.setup,
      ...(Object.hasOwn(driverCopy, "context") && { context: driverCopy.context }),
      ...(Object.hasOwn(driverCopy, "wrongWay") && { wrongWay: driverCopy.wrongWay }),
      ...(back && { back }),
      ...(forward && { forward })
    }
  }

  if(cleanedLane.status){
    cleanedLane.showlane = null;
  }

  if(cleanedCapturePlace.mobile && cleanedLane.type !== "INTERNAL_SMARTCAPTURE"){
    cleanedLane.noctime = null;
  }

  const validLane = validDriver ? {
    ...cleanedLane,
    smartcaptureDriver: validDriver
  }: cleanedLane

  const integrations = formData.integrations?.length > 0 ? [
    {
      laneCode: validLane.code ?? null,
      type: "VMS",
      cameraId: null,
      externalConfig: formData.integrations
    }
  ] : [];

  const formatedObj = {
    capturePlace: cleanedCapturePlace,
    route: cleanedRoute,
    lane: validLane,
    integrations
  }

  const formDataPayload = new FormData();

  const jsonBlob = new Blob([JSON.stringify(formatedObj)], {
    type: "application/json"
  });

  formDataPayload.append("model", jsonBlob);

  if (attach) {
    formDataPayload.append("file", attach);
  }

  return formDataPayload
}

function prepareSmartcaptureDriver(smartcaptureDriver, setup){
  if(!setup){
    return null;
  }

  const temp = structuredClone(smartcaptureDriver);

  ["back", "forward"].forEach(position => {
    const {smartLooptype, model_details = {}, ...camera} = temp[position] ?? {};
    const cleanedModelDetails = {...model_details};

    if (!MODELS_WITH_EXTRA_SETTINGS.includes(temp[position]?.model)) {
      EXTRA_SETTINGS_MODEL_DETAIL_KEYS.forEach(key => delete cleanedModelDetails[key]);
    }

    temp[position] = {
      ...camera,
      model_details: {
        ...cleanedModelDetails,
        ...(smartLooptype !== undefined && {smartLooptype}),
      },
    };
  });

  switch(setup){
    case "back":
    case "forward": {
      const { driver, model } = temp[setup];

      if(driver === "Pumatronix"){
        if(!(model === "600-API" || model === "450-API" || model === "VTR600")){
          temp[setup].disableConnection = true
        }
      }
      else {
        temp[setup].model_details = {
          ...temp[setup].model_details,
          netSDK: model === "NetSDK" ? "true" : "false"
        }
      }

      // por uma questão de compatibilidade esse valor é o oposto
      temp[setup].disableConnection = !temp[setup].disableConnection;
      temp.context = 0 // dado legado
      temp.wrongWay = temp[setup].model_details?.wrongWay ?? false;
      break;
    }
    case "forwardback": {
      const { driver: backDriver } = temp.back;
      const { driver: forwardDriver } = temp.forward;

      if(backDriver === "Pumatronix"){
        temp.back.disableConnection = true
      }

      if(forwardDriver === "Pumatronix"){
        temp.forward.disableConnection = true
      }
      // por uma questão de compatibilidade esse valor é o oposto
      temp.back.disableConnection = !temp.back.disableConnection
      temp.forward.disableConnection = !temp.forward.disableConnection
      temp.wrongWay = false
      break;
    }
  }

  return temp
}

function applyEndpointOnlyModelPayloadDefaults(camera){
  if(!ENDPOINT_ONLY_CAMERA_MODELS.includes(camera?.model)){
    return camera;
  }

  return {
    ...camera,
    port: "80",
    model_details: {
      ...(camera.model_details ?? {}),
      user: "",
      password: ""
    }
  }
}

function normalizeCameraPort(camera) {
  if (!Object.hasOwn(camera, "port") || camera.port == null) return camera;

  return {
    ...camera,
    port: String(camera.port)
  };
}

export function translateError(message, method) {
  if (message instanceof Object && message.name.includes("invalid.latlon.city")) {
    const valueDecode = JSON.parse(message.value);
    return `As coordenadas (latitude e longitude) não correspondem com o município selecionado. <br /> Os valores informados pertencem à ${valueDecode.foundCity}`;
  }

  switch (message) {
    case 'lane.cant.change.type':
      return 'Não é possível alterar tipo de dispositivo de uma câmera "Móvel" ou  "App Captura Móvel".'
    case 'lane.cant.change.adr':
      return 'Não é possível desativar a leitura de produtos perigosos, pois essa câmera está cadastrada em um monitoramento.'
    case 'lane.cant.delete.monitoring.items':
      return 'Não é possível excluir, pois há um monitoramento que possui apenas essa câmera cadastrada.'
    case 'pcl.mobile.cannotChange':
      return 'Não é possível alterar "Móvel" de um ponto já cadastrado.'
    case 'descriptionPcl.already.registered':
      return "Nome do Ponto de coleta já existente."
    case 'descriptionRoute.already.registered':
      return "Nome do Sentido já existente."
    case 'lanes.limit.exceeded':
      return 'Limite de licenças atingido.'
    case 'invalid.latlon.city':
      return 'As coordenadas (latitude e longitude) não correspondem com o município selecionado.'
    case 'lane.smartcapture.cameraip.port.already.exists':
      return '"Endereço da câmera" já existente.'
    case 'lane.smartcapture_forwardback.cameraip.port.already.exists':
      return 'O "Endereço da câmera" traseira e dianteira não podem ser iguais.'
    case 'lane.cant.change.restricted':
      return 'Não é possível desabilitar "permissão de acesso restrito". Câmera está relacionada em uma função.'
    case 'lane.has.passages':
      return "Câmera possui passagens."
    default:
      switch(method){
        case "create":
        case "update":
          return "Não foi possível salvar"
        case "delete":
          return "Não foi possível excluir"
        default:
          return "Não foi possível executar a ação desejada"
      }
  }
}

export function handleDriverNameOnUrl(driver, model){
  let correctDriver = driver?.toLowerCase() ?? "";
  if(correctDriver === "pumatronix" && model === "450-API"){
    correctDriver = "pumatronixAPI"
  }
  return correctDriver;
}
